import type {ReactNode} from 'react';

export interface MarkdownRendererProps {
  content: string;
  suffix?: ReactNode;
}

export const SUFFIX_CONTAINER_CLASS = 'markdown-suffix';

export const SUFFIX_CONTAINER_MARGIN_LEFT = '2px';

export const SUFFIX_ANCHOR_SELECTOR = 'p, li, h1, h2, h3, h4, h5, h6, blockquote, dd, td, th, figcaption';
